import React, {Component} from 'react';
import PropTypes from 'prop-types';
import HoverOver from "./HoverOver";

const styles = {
  wrapper: {
    display: 'inline-block',
    position: 'relative'
  },
  svg: {
    overflow: 'visible'
  },
  circle: {
    transition: 'fill .8s'
  }
};

const fillColor = v => {
  if (v > 75) {
    return '#2980b9';
  }
  else if (v < 25) {
    return '#444';
  }
  else {
    return '#ccc';
  }
};

class PercentileDot extends Component {

  constructor(props) {
    super(props);

    this.state = {
      hover: null
    };
  }

  getValue() {
    const stats = this.props.stats ? this.props.stats : {};
    return stats[this.props.property] || 0;
  }

  getPercentile() {
    const stats = this.props.stats ? this.props.stats : {};
    const percentiles = stats.percentile ? stats.percentile : {};
    return percentiles[this.props.property];
  }

  getHover() {
    const content = (
      <div>
        <h4>{this.props.label}</h4>
        <div><b>Season Total</b> : <i>{this.getValue()}</i></div>
        <div><b>Percentile</b> : <i>{this.getPercentile()}th</i></div>
      </div>
    );

    return {x: 6, y: 7, direction: 'left', content};
  };

  mouseEnter() {
    this.setState({hover: this.getHover()});
  }

  mouseExit() {
    this.setState({hover: null});
  }

  render() {
    const fill = fillColor(this.getPercentile());

    return (
      <div style={styles.wrapper}>
        <svg style={styles.svg} width={24} height={11}>
          <circle
            style={styles.circle}
            r={6.5} cx={6} cy={6}
            fill={fill}
            onMouseEnter={this.mouseEnter.bind(this)}
            onClick={this.mouseEnter.bind(this)}
            onMouseOut={this.mouseExit.bind(this)}/>
        </svg>
        <strong>{this.props.label}</strong>
        <HoverOver data={this.state.hover}/>
      </div>
    )
  }
}

PercentileDot.propTypes = {
  stats: PropTypes.object,
  property: PropTypes.string,
  label: PropTypes.string
};

export default PercentileDot


// WEBPACK FOOTER //
// ./src/components/PercentileDot.js